import { Flex, Text } from '@fluentui/react-northstar';

export const FeatureItem = (props: any) => {
    return <Flex gap="gap.medium"
        hAlign="center" vAlign="center">
        {props.icon}
        <Text size="large">{props.text}</Text>
    </Flex>
}